import { Services } from './services';
import { actions } from 'shared/actions/app';
import { History } from 'history';
import { applyMiddleware, createStore, Reducer } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import makeRootReducers from 'shared/reducers';

type ConfigureStoreArg<RootState> = {
  componentsReducer: Reducer;
  history: History;
  initialState: RootState;
  services: Services;
};

function configureStore<RootState>({
  componentsReducer,
  history,
  initialState,
  services,
}: ConfigureStoreArg<RootState>) {
  const sagaMiddleware = createSagaMiddleware({
    context: services,
  });

  const middlewares = [sagaMiddleware, routerMiddleware(history)];

  if (process.env.NODE_ENV === 'development' && !__ISSERVER__) {
    const { createLogger } = require('redux-logger');
    const logger = createLogger({ collapsed: true });
    middlewares.push(logger);
  }

  if (process.env.NODE_ENV === 'development' && __ISSERVER__) {
    middlewares.push(() => (next) => (action) => {
      console.log(action.type);
      next(action);
    });
  }

  const store = createStore(
    makeRootReducers(history, componentsReducer),
    initialState,
    composeWithDevTools(applyMiddleware(...middlewares))
  );

  return {
    close: () => store.dispatch(actions.end()),
    runSaga: sagaMiddleware.run,
    store,
  };
}

export { configureStore };
